import { render, staticRenderFns } from "./b5Step.vue?vue&type=template&id=8d07d27e&scoped=true&"
import script from "./b5Step.vue?vue&type=script&lang=js&"
export * from "./b5Step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d07d27e",
  null
  
)

export default component.exports